<template>
  <ol class="breadcrumb my-auto">
    <li class="breadcrumb-item my-auto active pointer-click" aria-current="page"
        v-on:click="showThemeSelector = true;"
        v-if="!showThemeSelector">
      {{ datahelper.theme_list.find(theme => theme.id === selectedTheme).label }}
      <icon :icon="['far', 'caret-down']" class="fa-1x my-auto"/>
    </li>
    <li class="breadcrumb-item my-auto active d-flex" aria-current="page" v-if="showThemeSelector"
    >
      <div class="input-group">
        <select class="form-select form-select-sm my-auto" aria-label="Theme select"
                v-model="selectedThemeComp"
        >
          <option :value="themeItem.id"
                  v-on:click="selectOption"
                  v-for="themeItem in themes">
            {{ themeItem.label }}
          </option>
        </select>
        <button class="btn btn-sm btn-primary" type="button" v-on:click="showThemeSelector = false;">
          <icon :icon="['fal', 'x']" class="fa-1x my-auto"/>
        </button>
      </div>
    </li>
  </ol>
</template>
<script>
import {mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: 'BreadcrumbTheme',
  data: function () {
    return {
      showThemeSelector: false
    }
  },
  computed: {
    ...mapState([
      'posters', 'mode', 'fullscreen', 'loader', 'themes', 'datahelper', 'ratings'
    ]),
    ...mapState('theme', ['firstLevelTheme', 'secondLevelTheme', 'selectedTheme']),
    selectedThemeComp: {
      get() {
        return this.selectedTheme
      },
      set(id) {
        this.setSelectedTheme(id);
      }
    }
  },
  methods: {
    ...mapMutations('theme', ['setFirstLevelTheme', 'setSecondLevelTheme', 'setSelectedTheme']),
    selectOption() {
      this.showThemeSelector = false;
    }
  },
}
</script>
